module.exports = __webpack_public_path__ + "media/promo/promo/images/soc-4-353177d44a31a236d3ff9367280b2741.svg";